const fromPlaceByIdQueryToPlaceById = (data) => {
  if (!data) {
    return null;
  }
  const {
    coordinates: { lat, lon }
  } = data;
  return { coordinates: { lat, lon } };
};
export {
  fromPlaceByIdQueryToPlaceById as default
};
//# sourceMappingURL=fromPlaceByIdQueryToPlaceById.js.map
